import { combineReducers } from 'redux';
import { online } from './online';
import { auth } from './auth';
import { menu } from './menu';

const rootReducer = combineReducers({
  online,
  auth,
  menu
});

export { rootReducer };
